import { render, staticRenderFns } from "./NsAnimateHeight.vue?vue&type=template&id=334c525f&scoped=true&"
import script from "./NsAnimateHeight.vue?vue&type=script&lang=js&"
export * from "./NsAnimateHeight.vue?vue&type=script&lang=js&"
import style0 from "./NsAnimateHeight.vue?vue&type=style&index=0&id=334c525f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "334c525f",
  null
  
)

export default component.exports